import { IUserGroup } from "./IUserGroup";
import { EUserGroupRoles } from "./eUserGroupRoles";
import { EUserGroupTypes } from "./eUserGroupTypes";

export class UserGroup implements IUserGroup {
    displayName: string;
    userGroupType: EUserGroupTypes;
    groupName: string;
    userGroupRole: EUserGroupRoles | null;
    hasGroup: boolean;
    objectId: string;

    constructor(displayName: string, userGroupType: EUserGroupTypes, groupName: string, userGroupRole: EUserGroupRoles | null, hasGroup: boolean, objectId: string) {
        this.displayName = displayName;
        this.userGroupType = userGroupType;
        this.groupName = groupName;
        this.userGroupRole = userGroupRole;
        this.hasGroup = hasGroup;
        this.objectId = objectId;
    }



}
